<n-slide-window *ngIf="pageReady"
    [(visible)]="windowVisible"
    [loading]="loading"
    width="7.5rem"
    (onHide)="close()">
    <n-header>
        <h1>{{i18n.title.addDataTurboUser}}</h1>
        <n-help-link key="DataTurboAddUser"></n-help-link>
    </n-header>

    <!-- 表单 -->
    <form [formGroup]="vm"
        [errorMessage]="errorMessage"
        class="common-form">
        <!-- 用户类型 -->
        <n-form-item [label]="i18n.label.type"
            [required]="true">
            <n-select id="add-user-type"
                [options]="userTypeOpts"
                formControlName="userType">
            </n-select>
        </n-form-item>
        <!-- 用户选择 -->
        <n-form-item *ngIf="isDataTurbo | fn :userType"
            [labelHide]="true">
            <!-- 校验提示 -->
            <n-tip *ngIf="showErrorMsg"
                [type]="'failed'"
                [content]="i18n.error.atLeastSelectOneTip">
            </n-tip>
            <!-- 推拉表格 -->
            <n-transfer-table #transferTable
                id="add-user-table"
                [leftTitle]="i18n.label.leftTransferTitle"
                [rightTitle]="i18n.label.rightTransferTitle"
                [config]="tableConfig"
                [leftColumnDefs]="tableColumns"
                [data]="userData"
                [(selection)]="windowsSelection"
                (selectionChange)="onSelectionChange()">
            </n-transfer-table>
        </n-form-item>
        <!-- 权限等级 -->
        <n-form-item [label]="i18n.label.permissionLevel" [required]="false">
            <span>{{i18n.label.readAndWritePermission}}</span>
        </n-form-item>
    </form>

    <n-footer>
        <button id="select-user-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.btn.okBtn"
            (click)="onOk()">
        </button>
        <button id="select-user-cancel-btn"
            nButton
            [label]="i18n.btn.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
